var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonDefault',{attrs:{"button-name":_vm.$t('shooting.buttons.player.player'),"outlined":true,"loading":_vm.loading},on:{"click":_vm.goToPlayer}})
}
var staticRenderFns = []

export { render, staticRenderFns }